module.exports = __webpack_public_path__ + "static/media/operation-overview.4beffed9.svg";